'use strict';

angular.module('far.admin')
	.controller('UserEditController', function ($log, $http, $window, form, User, $scope, autocomplete) {
		var vm = {
			progress: true,
			userModel: form('userModel'),
			getUser: getUser,
			submit: submit,
			alerts: [],
			closeAlert: function(index) {
				vm.alerts.splice(index, 1);
			}
		};

		vm.userModel
			.addField('user_date', 'uiDatepicker', {
				validators: {
					required: true
				},
				options: {
					placeholder: 'Дата'
				},
				label: 'Дата восхождения:'
			})
			.addField('user_mountain_route', 'uiSelect', {
				validators: {
					required: true
				},
				label: 'Маршрут',
				options: {
					onSelect: 'field.uiSelectOptions.onSelect($item)'
				},
				uiSelectOptions: {
					matchTitle: '{{ $select.selected.name }}',
					choicesTitle: '{{ item.name }}',
					match: {
						placeholder: 'Выберите маршрут...'
					},
					choices: {
						repeat: 'item in field.items track by item.id',
						refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "MountainRoute", "mountainRoutes")',
						refreshDelay: 0
					},
					refreshAutoComplete: autocomplete.refreshAutoComplete,
					onSelect: function (item) {
						if (item) {
							vm.user.user_mountain_route = item;
						}
					}
				}
			}, autocomplete.get('mountainRoutes'))
            .addField('members_new', 'userSelect', {
                validators: {
                    required: true
                },
                label: 'Руководитель',
                uiSelectOptions: {
                    match: {
                        placeholder: 'Выберите руководителя...'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userChiefs")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.user.user_chief = item;
                        }
                    }
                }
            }, autocomplete.get('userChiefs'))
            .addField('user_instructor', 'userSelect', {
                validators: {
                    required: true
                },
                label: 'Инструктор',
                uiSelectOptions: {
                    match: {
                        placeholder: 'Выберите инструктора...'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Instructors", "userInstructors")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.user.user_instructor = item;
                        }
                    }
                }
            }, autocomplete.get('userInstructors'))
            .addField('user_participant', 'userSelect', {
                validators: {
                    required: true
                },
                label: 'Участник',
                uiSelectOptions: {
                    match: {
                        placeholder: 'Выберите участника...'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userParticipants")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item, model, options) {
                        if (item) {
                            vm.user.user_participants[options.index] = item;
                        }
                    }
                }
            }, autocomplete.get('userParticipants'))
			.addField('document_file', 'fileUpload', {
				validators: {
					required: true
				},
				label: 'Загрузить документ',
				uploader: {
					url: Routing.generate('api_upload_post_file'),
					autoUpload: true,
					onBeforeUploadItem: function (item) {
						item.formData = [{hash: vm.user.documents, entity: 'User'}];
					},
					onSuccessItem: function (item, response) {
						item.serverData = response;
					},
					removeFromQueue: function (value) {
						var index = this.getIndexOfItem(value);
						var item = this.queue[index];

						if (item.isUploading) {
							item.cancel();
						} else {
							vm.documents_files.splice(index, 1);
						}

						this.queue.splice(index, 1);

						item._destroy();

						this.progress = this._getTotalProgress();
					}
				},
				fieldData: {
					getUrl: function(item) {
						if ( item.serverData !== undefined ) {
							return Routing.generate('api_upload_get_file', {fileStorage: item.serverData.id});
						}
					}
				}
			});

		function getUser() {
			if (arguments.length) {
				vm.user = User.get(arguments[0], function (userData) {
					vm.user.user_participants = [];

					angular.forEach(userData.user_users, function (user_user, i) {
						switch ( user_user.user_user_type_id.system_name ) {
							case 'chief':
								vm.user.user_chief = user_user.user;
								break;
							case 'instructor':
								vm.user.user_instructor = user_user.user;
								break;
							default:
								vm.user.user_participants.push(user_user.user);
								break;
						}
					});

					if (vm.user.user_participants.length == 0) {
						vm.user.user_participants.push();
					}

					vm.user.user_date = new Date(vm.user.user_date);

					vm.progress = false;
				});
			} else {
				vm.user = User.new({
					user_participants: [],
					documents_files: []
				});

				vm.progress = false;
			}
		}

		// TODO: Success сообщения для всей админки
		function submit() {
			vm.user.save()
				.then(function () {
					//$window.location.href = Routing.generate('admin_users');
				})
				.catch(function (response) {
					$log.error(response);
					vm.alerts.push({
						type: 'danger',
						message: 'Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.'
					});
				});
		}

		return vm;
	});
